import React, { useState, useEffect } from "react";
import { Button } from "../../../../shadcn/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../shadcn/ui/dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "../../../../shadcn/ui/drawer";
import InstanceLocationPicker from "./InstanceLocationPicker";
import { MapPin } from "lucide-react";

const LocationPickerModal = ({ value, onChange, trigger }) => {
  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkIsDesktop = () => {
      setIsDesktop(window.matchMedia("(min-width: 768px)").matches);
    };

    checkIsDesktop();
    window.addEventListener("resize", checkIsDesktop);

    return () => window.removeEventListener("resize", checkIsDesktop);
  }, []);

  const handleConfirm = coords => {
    onChange(coords);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  // Prevent dialog from closing when clicking on Google Places autocomplete suggestions
  const handlePointerDownOutside = event => {
    const target = event.target;
    // Check if the click is on a Google Places autocomplete element
    if (
      target?.closest?.(".pac-container") ||
      target?.closest?.(".pac-item") ||
      target?.classList?.contains("pac-container") ||
      target?.classList?.contains("pac-item") ||
      target?.closest?.("[data-pac-container]") ||
      // Also check for the autocomplete input to prevent issues
      target?.id === "instance-pac-input" ||
      target?.closest?.("#instance-pac-input")
    ) {
      event.preventDefault();
    }
  };

  // Also prevent interact outside for autocomplete elements
  const handleInteractOutside = event => {
    const target = event.target;
    if (
      target?.closest?.(".pac-container") ||
      target?.closest?.(".pac-item") ||
      target?.classList?.contains("pac-container") ||
      target?.classList?.contains("pac-item") ||
      target?.closest?.("[data-pac-container]")
    ) {
      event.preventDefault();
    }
  };

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>{trigger}</DialogTrigger>
        <DialogContent
          className="sm:max-w-3xl h-[85vh] overflow-hidden flex flex-col"
          onPointerDownOutside={handlePointerDownOutside}
          onInteractOutside={handleInteractOutside}
        >
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              Select Location
            </DialogTitle>
            <DialogDescription>
              Search or click on the map to set the exact location for this space unit.
            </DialogDescription>
          </DialogHeader>
          <div className="flex-1 overflow-hidden">
            <InstanceLocationPicker initialValue={value} onConfirm={handleConfirm} onCancel={handleCancel} />
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>{trigger}</DrawerTrigger>
      <DrawerContent
        className="h-[90vh]"
        onPointerDownOutside={handlePointerDownOutside}
        onInteractOutside={handleInteractOutside}
      >
        <DrawerHeader className="text-left">
          <DrawerTitle className="flex items-center gap-2">
            <MapPin className="w-5 h-5" />
            Select Location
          </DrawerTitle>
          <DrawerDescription>
            Search or click on the map to set the exact location for this space unit.
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 overflow-hidden px-4">
          <InstanceLocationPicker initialValue={value} onConfirm={handleConfirm} onCancel={handleCancel} />
        </div>
        <DrawerFooter className="pt-2">
          <DrawerClose asChild>
            <Button variant="outline">Cancel</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default LocationPickerModal;
